import * as React from "react";
import { useHistory } from "react-router-dom";

import { Button } from "@/components/ui";
import { WebComponents } from "@/interfaces";
import { URLS, useAccountSettings, useSocialCoachSession } from "@/utils";

import {
  readCoachVideoProjectsView,
  writeCoachVideoProjectsView,
  type CoachVideoProjectsView,
} from "./coachVideoProjectsView";
import { CoachVideoProjectKanban } from "./CoachVideoProjectKanban";
import VideoCreditUsageModal from "./VideoCreditUsageModal";
import { VideoProjectsLegacy } from "./VideoProjectsLegacy";

const VideoProjects: React.FC = () => {
  const history = useHistory();
  const { coachId } = useSocialCoachSession();
  const { hasWritePermission } = useAccountSettings();
  const writePermission = hasWritePermission(WebComponents.VIDEO_CATALYST);

  const [view, setView] = React.useState<CoachVideoProjectsView>(readCoachVideoProjectsView);
  const [showCreditUsage, setShowCreditUsage] = React.useState(false);
  const isBoard = view === "board";

  const setAndStoreView = (next: CoachVideoProjectsView) => {
    writeCoachVideoProjectsView(next);
    setView(next);
  };

  const experienceToggle = (
    <Button variant="outline" onClick={() => setAndStoreView(isBoard ? "legacy" : "board")}>
      {isBoard ? "Go back to old experience" : "Try new experience"}
    </Button>
  );

  const sharedActions = writePermission ? (
    <div className="flex gap-4 items-center flex-wrap">
      <Button variant="outline" onClick={() => setShowCreditUsage(true)}>
        Credit Usage Report
      </Button>
      <Button onClick={() => history.push(URLS.coach.newVideoProject)}>New Project</Button>
    </div>
  ) : null;

  return (
    <>
      {isBoard ? (
        <CoachVideoProjectKanban experienceToggle={experienceToggle} sharedActions={sharedActions} />
      ) : (
        <VideoProjectsLegacy experienceToggle={experienceToggle} sharedActions={sharedActions} />
      )}
      <VideoCreditUsageModal open={showCreditUsage} onOpenChange={setShowCreditUsage} coachId={coachId} />
    </>
  );
};

export default VideoProjects;
